module.exports = __webpack_public_path__ + "static/media/kz.dfd02844.webp";